import React, { useState, useEffect, useRef, useCallback } from 'react';
import style from './ServicePolicy.module.css';
import { useNavigate } from 'react-router-dom';
import URL from '../../../../constants/url';
import noDataImg from '../../../../images/common/i_3d_no_data_doc.svg';

import HeadSub from '../../../../components/comm/HeadSub';


import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import { formatDate } from '../../../../assets/js/comm';

import ToastPopup from '../../../../components/comm/ToastPopup';

import Skeleton from '@mui/material/Skeleton';

const ServicePolicy = () => {

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const navigate = useNavigate();

    const [policyList, setPolicyList] = useState([]); 

    const [isInitialLoading, setIsInitialLoading] = useState(true); // 초기 로딩 상태 추가

    const retrieveAppPolicyList = useCallback(async () => {
        const url = "/setting/retrieveAppPolicyList";
        const jToken = localStorage.getItem('jToken');
        const reqOptions = { headers: { Authorization: jToken } };

        await axiosApi.post(url, {}, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setPolicyList([...res.data.result.policyList]);
                console.log(res.data.result.policyList)
            } else {
                setToastMessage(res.data.resultMessage);
                setToast(true);
            }
            setIsInitialLoading(false); // 초기 로딩 완료
        })
        .catch(err => {
            console.error("약관 목록 호출 중 오류  : ", err);
        })
    }, []);

    useEffect(() => {
        retrieveAppPolicyList();
    },[])

    
    return (
        <>
            <HeadSub title="서비스 약관 및 정책" />

            <div id="sub-content">
                <div className='inner-wrap' data-pad="normal">
                        <div className={style['guide-lists-box']}>
                            <ul>

                                {/* 초기 로딩 중일 때 스켈레톤 표시 */}
                                {isInitialLoading && (
                                    <>
                                        {[...Array(5)].map((_, idx) => (
                                            <li key={'skeleton_' + idx}>
                                                <p className={style['title']}>
                                                    <Skeleton variant="text" width="140px" height={24} style={{ marginBottom: '8px' }} />
                                                </p>
                                            </li>
                                        ))}
                                    </>
                                )}

                                {/* no-data */}
                                {!isInitialLoading && policyList.length === 0 &&
                                    <li className={style['no-data-box']}>
                                        <div className={style['img-box']}>
                                            <object data={noDataImg} aria-hidden='true'></object>
                                        </div>
                                        <p>약관 및 정책이 없습니다.</p>
                                    </li>
                                }
                                
                                {!isInitialLoading && policyList.length > 0 &&
                                    policyList.map((item, idx) => {
                                        return (
                                            <li key={'policy_' + idx} onClick={()=> navigate(URL.SERVICE_POLICY_DETAIL, {state : {id : item.id , stplatPolicySeCd : item.stplatPolicySeCd}})}>
                                                <p className={style['title']}>{item.stplatPolicySj}</p>
                                            </li>
                                        );
                                    })
                                   
                                }
                            </ul>
                        </div>
                    

                </div>
            </div>
            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position="center"
                    opacity="90"
                />
            )}
        </>
    );
};

export default ServicePolicy;
